<form [class]="classPrefix('MainPod')">
  <section [class]="classPrefix('Pod1')">
    <wml-form-zero [class]="classPrefix('Pod1Item0') + classPrefix('Pod1Form0')" [props]="mainForm"></wml-form-zero>
  </section>
  <section [class]="classPrefix('Pod2')">
    <wml-button-one [props]="mainFormSubmitBtn"></wml-button-one>
  </section>
</form>
